import { render } from "./ActivitiesIndex.vue?vue&type=template&id=4325cdef"
import script from "./ActivitiesIndex.vue?vue&type=script&lang=js"
export * from "./ActivitiesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__